import { FormControlLabel, FormGroup, Stack, Typography } from "@mui/material";
import Switch from "@mui/material/Switch";
import ThemeContext from "components/app/Context";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useState } from "react";
import { tokens } from "styles/Tokens";
interface Props {
  isToggleEnabled?: boolean;
  onChange: (val: boolean) => void;
  labelOn?: string;
  labelOff?: string;
  isLabelLeftSide?: boolean;
  sx?: {};
}

export default function Toggle(props: Props) {
  const translate = useTranslate();
  const {
    isToggleEnabled,
    onChange,
    labelOn = translate("common.inProgress"),
    labelOff = translate("common.not.inProgress"),
    sx,
    isLabelLeftSide = false
  } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [isToggle, setIsToggle] = useState(isToggleEnabled);

  const getLabelView = () => {
    return (
      <>
        <Typography
          variant="body2"
          color={tokens.Text.General.PrimaryHeadline}
          marginLeft={isMobileScreen ? "13px" : "4px"}
          paddingY={isMobileScreen ? "8px" : "none"}
        >
          {isToggle ? labelOn : labelOff}
        </Typography>
      </>
    );
  };

  const getToggleView = () => {
    return (
      <>
        <Switch
          size="small"
          defaultChecked={isToggleEnabled}
          checked={isToggleEnabled}
          onChange={(e) => {
            setIsToggle(!isToggle);
            onChange(e.target.checked);
          }}
          sx={{ ...sx }}
        />
      </>
    );
  };

  return (
    <Stack direction={"row"}>
      <FormGroup>
        <FormControlLabel
          control={isLabelLeftSide ? getLabelView() : getToggleView()}
          label={isLabelLeftSide ? getToggleView() : getLabelView()}
        />
      </FormGroup>
    </Stack>
  );
}
